import { render, staticRenderFns } from "./WantedAlert.vue?vue&type=template&id=7b2c44d2&scoped=true&"
import script from "./WantedAlert.vue?vue&type=script&lang=js&"
export * from "./WantedAlert.vue?vue&type=script&lang=js&"
import style0 from "./WantedAlert.vue?vue&type=style&index=0&id=7b2c44d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2c44d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCol,VDivider,VRow})
